import useUserAuthentication from "~/hooks/contexts/useUserAuthentication";
import Modal from "./Modal";

export default function MissingInformationModal() {
  const { user } = useUserAuthentication();

  return user !== null && user !== undefined ? (
    <Modal />
  ) : null;
}
